/**
 * Archive functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalHeader {
  /**
   * Constructs a new Archive instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.archiveToggle = this.element.querySelector('[data-component="archive-toggle"]')

    this.archiveToggle.addEventListener('click', () => {
      this.element.classList.toggle('open')
      document.body.classList.toggle('archive-open')
    })

  }
}



// WEBPACK FOOTER //
// ./components/archive/index.js